import React from 'react';
import PropTypes from 'prop-types';
import { Modal, designSystem } from '@yola/ws-ui';
import { i18next, dialogs, utils } from '@yola/ws-sdk';
import useCustomerSupport from 'yola-editor/src/js/modules/common/hooks/use-customer-support';
import useMatchBreakpoint from '../../utils/custom-hooks/use-match-breakpoint';

const { IconButton, Box, Tag, Heading, Paragraph, ActionButton, HorizontalStack } = designSystem;

const DESKTOP_VIEW_BREAKPOINT = '768px';

const PageLimitDialog = ({ pageLimit, onAfterClose = utils.noop }) => {
  const isDesktopView = useMatchBreakpoint(DESKTOP_VIEW_BREAKPOINT);
  const { onContactSupport, isCustomerSupportAvailable } = useCustomerSupport();

  const handleClose = () => {
    dialogs.operations.hide();
    onAfterClose();
  };

  const handleContactSupportClick = () => {
    onContactSupport();
    handleClose();
  };

  return (
    <Modal
      className="ws-page-limit-dialog"
      width={500}
      height="auto"
      fullscreen={!isDesktopView}
      centered
      draggable={false}
      resizable={false}
      overlay="visible"
    >
      <Box
        paddingTop="spacing-l"
        paddingLeft="spacing-xl"
        paddingRight="spacing-xl"
        paddingBottom="spacing-xl"
      >
        <div className="ws-page-limit-dialog__close-button">
          <IconButton glyph="close" size="medium" onClick={handleClose} transparent />
        </div>
        <Box marginBottom="spacing-2-xs">
          <Tag
            size="semi-small"
            appearance="white"
            label={i18next.t(`${pageLimit}/${pageLimit} pages used`)}
          />
        </Box>
        <Box marginBottom="spacing-xs">
          <Heading type="heading-3">{i18next.t(`You’ve used all ${pageLimit} pages`)}</Heading>
        </Box>
        <Box marginBottom="spacing-m">
          <Paragraph size="large">
            {i18next.t(
              'Delete unnecessary pages to add new ones. If you need further assistance, reach our contact support for help.'
            )}
          </Paragraph>
        </Box>
        <div>
          <HorizontalStack gap="spacing-m">
            <ActionButton
              size="extra-large"
              fontSize="large"
              format="solid"
              label={i18next.t('Continue editing')}
              onClick={handleClose}
            />
            {isCustomerSupportAvailable && (
              <ActionButton
                format="text"
                size="extra-large"
                fontSize="large"
                label={i18next.t('Contact support')}
                onClick={handleContactSupportClick}
              />
            )}
          </HorizontalStack>
        </div>
      </Box>
    </Modal>
  );
};

PageLimitDialog.propTypes = {
  pageLimit: PropTypes.number.isRequired,
  onAfterClose: PropTypes.func,
};

export default PageLimitDialog;
